import { util } from 'utils'

export const transformSubCategoryResponse = payload => {
    const payloadCategory = payload
    const parsedSubCategories = []
    if (payload && payload.subcategory) {
        payload.subcategory.forEach(subCategory => {
            if (subCategory.type && subCategory.items && subCategory.items.length) {
                const parsedSubCategory = {
                    display_name: subCategory.name,
                }
                const products = []
                subCategory.items.forEach(product => {
                    const parsedProduct = util.parseProduct(product)
                    if (parsedProduct) products.push(parsedProduct)
                })
                parsedSubCategory.content = products
                parsedSubCategories.push(parsedSubCategory)
            }
        })
    }

    payloadCategory.lastFetched = new Date()
    payloadCategory.content = parsedSubCategories
    return payloadCategory
}

export const transformApplySubFilter = payload => {
    const parsedSubCategories = []
    if (payload && payload.subcategory) {
        payload.subcategory.forEach(subCategory => {
            if (
                subCategory.type &&
                subCategory.items &&
                subCategory.items.length &&
                subCategory.name !== 'CBD'
            ) {
                const parsedSubCategory = {
                    display_name: subCategory.name,
                    localisedName: subCategory.localisedName,
                }
                const products = []
                subCategory.items.forEach(product => {
                    const parsedProduct = util.parseProduct(product)
                    if (parsedProduct) products.push(parsedProduct)
                })
                parsedSubCategory.content = products
                parsedSubCategories.push(parsedSubCategory)
            }
        })
    }
    return parsedSubCategories
}

export const parseSubcategoryProducts = items => {
    const parsedItems = []
    for (let loop = 0; loop < items.length; loop++) {
        const parsedProduct = util.parseProduct(items[loop])
        if (parsedProduct) parsedItems.push(parsedProduct)
    }
    return parsedItems
}
